/* istanbul ignore file */

import { deletePadrao, getPadraoComRetorno, postPadraoComRetorno, putPadraoComRetorno } from 'services/api';
import { duckTodosPostosAtendimentoListar, duckPostosAtendimentoDetalhar } from 'store/ducks/postosAtendimento';
import { ID_POSTOS_ATENDIMENTO_DETALHAR } from 'utils/consts';
import { postosAtendimentoDetalhar } from 'routes/paths';

export const fetchSalvarNovoPostoAtendimento = posto => dispatch => {
  return new Promise(resolve => {
    const url = `PostoAtendimento`;
    dispatch(postPadraoComRetorno(url, posto)).then(res => resolve(res));
  });
};

export const fetchSalvarPostoAtendimentoEditado = posto => dispatch => {
  return new Promise(resolve => {
    const url = `PostoAtendimento`;
    dispatch(putPadraoComRetorno(url, posto)).then(res => resolve(res));
  });
};

export const fetchGetPostosAtendimentoByFilter = (page, itemsByPage) => dispatch => {
  const url = `PostoAtendimento/page=${page}&itemsByPage=${itemsByPage}`;
  dispatch(duckTodosPostosAtendimentoListar({ list: [] }));
  dispatch(getPadraoComRetorno(url, true)).then(res => {
    dispatch(duckTodosPostosAtendimentoListar(res));
  });
};

export const fetchDetalharPostoAtendimentoPorId = (id, history) => dispatch => {
  const url = `PostoAtendimento/${id}`;
  dispatch(getPadraoComRetorno(url)).then(retorno => {
    dispatch(duckPostosAtendimentoDetalhar(retorno));
    localStorage.setItem(ID_POSTOS_ATENDIMENTO_DETALHAR, id);
    history.push(postosAtendimentoDetalhar);
  });
};

export const fetchDeletarPostoAtendimento = id => dispatch => {
  const url = `PostoAtendimento/${id}`;
  return new Promise((resolve, reject) => {
    dispatch(deletePadrao(url, () => {}))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};
